/**
 * @pibex/shared — API contracts shared by apps/web and apps/api.
 * FROZEN in Wave 0 (docs/features/harness/01_IMPLEMENTATION_PLAN.md). Do not rename.
 */
import { z } from 'zod';
export const USER_ROLES = ['admin', 'member'];
export const USER_STATUSES = ['active', 'disabled'];
export const INVITATION_STATUSES = ['pending', 'accepted', 'revoked'];
/** Normalizes an email the way every boundary must: trimmed + lowercased. */
export const normalizeEmail = (email) => email.trim().toLowerCase();
export const googleLoginSchema = z.object({ credential: z.string().min(1) });
export const createInvitationSchema = z.object({
    email: z.string().trim().toLowerCase().pipe(z.email()),
});
export const patchMemberSchema = z.object({ status: z.enum(USER_STATUSES) });
/** Route table — single source of truth for paths used by web and api. */
export const API = {
    health: '/api/health',
    authGoogle: '/api/auth/google',
    authLogout: '/api/auth/logout',
    me: '/api/me',
    adminMembers: '/api/admin/members',
    adminMember: (id) => `/api/admin/members/${id}`,
    adminInvitations: '/api/admin/invitations',
    adminInvitation: (id) => `/api/admin/invitations/${id}`,
    adminInvitationResend: (id) => `/api/admin/invitations/${id}/resend`,
};
/** Name of the session cookie set by the api. */
// Firebase Hosting forwards ONLY a cookie named `__session` to Cloud Run — do not rename.
export const SESSION_COOKIE = '__session';
/** Trip facts used across the site. */
export const TRIP = {
    name: 'Pibex 2026',
    destination: 'Bariloche, Argentina',
    startDate: '2026-10-24',
    endDate: '2026-10-31',
};
//# sourceMappingURL=index.js.map